import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from './core/Global';
import { UserService } from './core/user.service';

@Injectable()

export class CampusService {
	public url: string = Global.url_seguros

	private _userService: UserService = inject(UserService)
	private _http = inject(HttpClient)

	getAll(): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'campus', { headers: headers })

	}

	create(campus: any): Observable<any> {
		let params = campus;
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'campus', params, { headers: headers })
	}

	update(campus: any): Observable<any> {
		let params = campus
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')
		return this._http.patch(this.url + 'campus/' + params._id, params, { headers: headers })
	}

}
